import React from 'react';
import { NavLink } from 'react-router-dom';

const V4Tabs = ({ active }) => {
  const linkClass = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;
  return (
    <ul className="nav nav-tabs mb-3">
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/upload">Upload</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/search">Search</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/assistant">Assistant</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/list">List</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/import">Import</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/chat-logs">Chat Trace</NavLink></li>
      <li className="nav-item"><NavLink className={linkClass} to="/v4/documents/settings">Settings</NavLink></li>
    </ul>
  );
};

export default V4Tabs;


